import React from "react";
import axios from "axios";
import { API_URL } from "../../config";
import moment from "moment";
import Pagination from "../../Pagination/Pagination";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";
import { useAppContext } from "../../Lib/ContextLib";

import Select from "react-select";

const filterSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: "10px",
    border: state.isFocused ? "1.5px solid #ffc107" : "1.5px solid #e2e8f0",
    boxShadow: state.isFocused ? "0 0 0 4px rgba(255, 193, 7, 0.15)" : "0 1px 2px rgba(0, 0, 0, 0.03)",
    padding: "2px 8px",
    fontSize: "0.95rem",
    backgroundColor: "#ffffff",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: state.isFocused ? "#ffc107" : "#cbd5e1",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected 
      ? "#ffc107" 
      : state.isFocused 
      ? "rgba(255, 193, 7, 0.1)" 
      : "#fff",
    color: state.isSelected ? "#000" : "#1e293b",
    padding: "10px 15px",
    cursor: "pointer",
    "&:active": {
      backgroundColor: "#ffc107",
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "12px",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    overflow: "hidden",
    border: "1px solid #e2e8f0",
    zIndex: 9999,
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
};

export default function LivePlayerApp() {
  const { accessObject } = useAppContext();
  const [dataRows, setdataRows] = React.useState([]);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [loader, setLoader] = React.useState(true);
  // const [filteredData, setFilteredData] = React.useState([]);

  const [pagination, setPagination] = React.useState({
    start: 1,
    end: showPrePage,
  });
  const [changeDeviceType, setChangeDeviceType] = React.useState(2);
  const [searchEmail, setSearchEmail] = React.useState("");
  const [changeStatus, setChangeStatus] = React.useState(3);
  const [totalLength, setTotalLength] = React.useState(1);

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 1, end: value });
  };

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const handleClearFilters = () => {
    setChangeStatus(3);
    setChangeDeviceType(2);
    setSearchEmail("");
    setPagination({ start: 1, end: showPrePage });
  };

  React.useEffect(() => {
    getBranch();
  }, [pagination.start, searchEmail, changeStatus, changeDeviceType]);

  const getBranch = () => {
    setLoader(true);
    axios
      .post(`${API_URL}/api/admin/player/get-all-live-player-details`, {
        pageNumber: pagination.start,
        recordLength: 10,
        deviceType: parseInt(changeDeviceType),
        search: searchEmail,
        kycStatus: parseInt(changeStatus),
      })
      .then(function (response) {
        setLoader(false);
        setdataRows(response.data.data.playerData);
        if (response.data.data?.totalLength !== 0) {
          setTotalLength(response.data.data?.totalLength);
        }
      })
      .catch(function (error) {
        console.log("getBranch error :::", error);
        setLoader(false);
      });
  };

  return (
    <div>
      <div className="content p-3">
        <div class="card ">
          <div className="pl-4 pr-4 pt-4">
            <div className="row align-items-end g-3">
              <div className="col-md-2">
                <label className="small text-muted font-weight-bold mb-1">KYC Status</label>
                <Select
                  styles={filterSelectStyles}
                  options={[
                    { value: 3, label: "All" },
                    { value: 2, label: "Not Verified" },
                    { value: 0, label: "Pending" },
                    { value: 1, label: "Verified" },
                  ]}
                  value={{
                    value: changeStatus,
                    label: changeStatus === 3 ? "All" : changeStatus === 2 ? "Not Verified" : changeStatus === 0 ? "Pending" : "Verified"
                  }}
                  onChange={(option) => {
                    setPagination({ ...pagination, start: 1 });
                    setChangeStatus(option.value);
                  }}
                />
              </div>
              <div className="col-md-2">
                <label className="small text-muted font-weight-bold mb-1">Device Type</label>
                <Select
                  styles={filterSelectStyles}
                  options={[
                    { value: 2, label: "All" },
                    { value: 0, label: "Android" },
                    { value: 1, label: "IOS" },
                  ]}
                  value={{
                    value: changeDeviceType,
                    label: changeDeviceType === 2 ? "All" : changeDeviceType === 0 ? "Android" : "IOS"
                  }}
                  onChange={(option) => {
                    setPagination({ ...pagination, start: 1 });
                    setChangeDeviceType(option.value);
                  }}
                />
              </div>
              <div className="col-md-3">
                <label className="small text-muted font-weight-bold mb-1">Search Player</label>
                <div className="position-relative">
                  <i className="fas fa-search text-muted position-absolute" style={{ left: '16px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, fontSize: '0.9rem' }}></i>
                  <input
                    className="form-control premium-search-input"
                    type="text"
                    placeholder="Email And Name ..."
                    value={searchEmail}
                    onChange={(e) => {
                      setPagination({ ...pagination, start: 1 });
                      setSearchEmail(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-md-5 d-flex justify-content-end align-items-end mt-3 mt-md-0" style={{ gap: '12px' }}>
                <button
                  type="button"
                  className="btn btn-premium-outline"
                  onClick={handleClearFilters}
                >
                  Clear Filter
                </button>
              </div>
            </div>
          </div>

          <div class="card-body" style={{ overflow: "scroll" }}>
            <table id="" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th scope="col" style={{ textAlign: "center" }}>
                    SrNo
                  </th>
                  <th scope="col" style={{ textAlign: "center" }}>
                    Date
                  </th>
                  <th scope="col" style={{ textAlign: "center" }}>
                    Name
                  </th>
                  <th scope="col" style={{ textAlign: "center" }}>
                    Email
                  </th>
                  <th scope="col" style={{ textAlign: "center" }}>
                    Balance
                  </th>
                  <th scope="col" style={{ textAlign: "center" }}>
                    Join Date
                  </th>
                  <th scope="col" style={{ textAlign: "center" }}>
                    Status
                  </th>
                </tr>
              </thead>
              {accessObject?.getLivePlayerAppList == true ? (
                <>
                  <tbody>
                    {!loader ? (
                      <>
                        {dataRows?.length > 0 ? (
                          <>
                            {dataRows
                              ?.slice(pagination.start, pagination.end)
                              .map((row, index) => (
                                <>
                                  <tr
                                    key={index}
                                    style={{ textAlign: "center" }}
                                  >
                                    <td style={{ textAlign: "center" }}>
                                      {index + 1 + pagination.start}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {moment(row.createdAt).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {row.name}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {row.email || "-"}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {row.balance}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {moment(row.createdAt).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {row.playerStatus}
                                    </td>
                                  </tr>
                                </>
                              ))}
                          </>
                        ) : (
                          <EmptyState colSpan={10} />
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </tbody>
                </>
              ) : (
                <>
                  <tr style={{ backgroundColor: "rgba(0,0,0,.05)" }}>
                    <td colSpan={8}>
                      <h5 className="text-center">Access Denied</h5>
                    </td>
                  </tr>
                </>
              )}
            </table>
            {accessObject?.getLivePlayerAppList == true && (
              <div className="mt-4">{loader && <Loader />}</div>
            )}
          </div>
          {totalLength != 0 && !loader && dataRows?.length != 0 && (
            <Pagination
              updateShowPerpagevalue={updateShowPerpagevalue}
              showPrePage={showPrePage}
              onPaginationChange={onPaginationChange}
              total={totalLength}
            />
          )}
        </div>
      </div>
    </div>
  );
}
